// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"5c807aa9","755":"f2a59c86","821":"f74d9e94","886":"f4fa7823","977":"04a9c7e6"}[chunkId] + ".chunk.js";
};